import { IM, IMLayout, useAlert, useLanguage } from '@infominds/react-native-components'
import { AuthenticationContainer } from '@infominds/react-native-license'
import React, { ReactNode } from 'react'
import BootSplash from 'react-native-bootsplash'

import version from '../versions.json'

type Props = { children: ReactNode | (({ authReady, isLoggedIn }: { authReady: boolean; isLoggedIn: boolean }) => ReactNode) }

export default function AuthenticationWrapper({ children }: Props) {
  const { language } = useLanguage()
  const { alert } = useAlert()

  return (
    <AuthenticationContainer
      config={{
        apiType: 'identityServer',
        projectCode: 'APP-DOCOK',
        moduleCode: 'APP',
        debug: __DEV__,
        disableVersionCheck: true,
      }}
      locale={language}
      versionsFile={version}
      onVersionCheckEnd={({ error }) => {
        error && alert(error.title, error.message)
      }}>
      {authContext => {
        const authReady = authContext && authContext.isLoggedIn !== undefined

        authReady && BootSplash.hide().catch(console.error)

        if (authContext === undefined || authReady === undefined || authContext.isLoggedIn === undefined) {
          return (
            // eslint-disable-next-line react-native/no-inline-styles
            <IM.View style={[IMLayout.flex.f1, { justifyContent: 'center' }]}>
              <IM.LoadingSpinner isVisible />
            </IM.View>
          )
        }

        return <>{typeof children === 'function' ? children({ authReady, isLoggedIn: authContext.isLoggedIn }) : children}</>
      }}
    </AuthenticationContainer>
  )
}
